import React from 'react';
import {expertiseItems} from "../../constants/services/customSoftware";
import SlideUp from "../ui/SlideUp";
import {useTranslation} from "react-i18next";

const Expertise = () => {
  const { t } = useTranslation();
  return (
    <section className="bg-sky-100">
      <div className="md:w-theme-container w-mobile-container mx-auto text-white py-28">
        <div className="max-w-7xl mx-auto text-center mb-16">
          <h2 className="text-3xl sm:text-4xl tracking-tight">
            <span className="text-theme-color">{t(`customizedDevelopmentPage.ourExpertise.experience`)} </span>
            <span className="text-black">{t(`customizedDevelopmentPage.ourExpertise.ourInnovation`)}</span>
          </h2>
          <p className="mt-4 text-lg text-black max-w-3xl mx-auto">
            {t(`customizedDevelopmentPage.ourExpertise.weSpecialize`)}
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {expertiseItems.map((item, index) => (
            <SlideUp
              key={index}
            >
              <div
                className="bg-theme-color rounded-2xl p-8 text-center transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
              >
                <div className="flex justify-center mb-5">
                  {item.svg}
                </div>
                <h3 className="text-xl text-white mb-3">{t(`customizedDevelopmentPage.ourExpertise.cards.${item.translationKeys.title}`)}</h3>
                <p className="text-white text-sm">{t(`customizedDevelopmentPage.ourExpertise.cards.${item.translationKeys.description}`)}</p>
              </div>
            </SlideUp>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Expertise;
